module.exports = __webpack_public_path__ + "img/575-42dfb3.png";